import { Plan, PlanDataExtracted } from '../../../types/plan';

export const planDataExtractor = (plan: Plan | null): PlanDataExtracted => {
  let sanitizedHeader = '';
  let sanitizedCurrency = '';
  let sanitizedPayDescriptionWeb = '';
  let sanitizedPayInterval = '';
  let sanitizedPlanDescription = '';
  let sanitizedPlanTitle = '';
  let sanitizedPricePerInterval = '';
  let sanitizedWithoutDiscount = '';
  let sanitizedSubheader = '';
  let sanitizedAmount = 0;
  let sanitizedAmountWithKlarnaInCents = 0;
  let sanitizedIsShortPlan = false;
  let sanitizedId = '';
  let sanitizedPriceWithoutBargainShort = 0;

  let sanitizedDescription = '';
  let sanitizedKlarnaDescription = '';
  let sanitizedMonthlyPriceShort = 0;
  let sanitizedWeeklyPriceShort = 0;
  let sanitizedNumberOfMonths = 0;
  let sanitizedInterval = '';
  let sanitizedPlanType;
  if (plan) {
    const { currency, metadata, amount, id, interval } = plan;
    sanitizedHeader = metadata?.header || '';
    sanitizedCurrency = currency === 'usd' ? '$' : '';
    sanitizedPayDescriptionWeb = metadata?.payDescriptionWeb || '';
    sanitizedPayInterval = metadata?.payInterval || '';
    sanitizedPlanDescription = metadata?.planDescription || '';
    sanitizedPlanTitle = metadata?.planTitle || '';
    sanitizedPricePerInterval = metadata?.pricePerInterval || '';
    sanitizedSubheader = metadata?.subheader || '';
    sanitizedWithoutDiscount = metadata?.withoutDiscount ? metadata.withoutDiscount.slice(0, 2) : '';
    sanitizedAmount = amount || 0;
    sanitizedAmountWithKlarnaInCents = metadata?.amountWithKlarnaInCents ? Number(metadata.amountWithKlarnaInCents) : 0;
    sanitizedIsShortPlan = metadata?.shortPlan === 'true';
    sanitizedId = id || '';

    sanitizedDescription = metadata.description || '';
    sanitizedKlarnaDescription = metadata?.klarnaDescription || '';
    sanitizedMonthlyPriceShort = Number(metadata.monthlyPrice) || 0;
    sanitizedWeeklyPriceShort = Number(metadata.weeklyPrice) || 0;
    sanitizedNumberOfMonths = metadata.numberOfMonths ? Number(metadata.numberOfMonths) : 0;
    sanitizedInterval = interval || '';
    sanitizedPriceWithoutBargainShort = Number(metadata.priceWithoutBargain) || 0;
    sanitizedPlanType = plan.type;
  }
  return {
    sanitizedHeader,
    sanitizedCurrency,
    sanitizedPayDescriptionWeb,
    sanitizedPayInterval,
    sanitizedPlanDescription,
    sanitizedPlanTitle,
    sanitizedPricePerInterval,
    sanitizedSubheader,
    sanitizedWithoutDiscount,
    sanitizedAmount,
    sanitizedIsShortPlan,
    sanitizedId,
    sanitizedDescription,
    sanitizedMonthlyPriceShort,
    sanitizedPriceWithoutBargainShort,
    sanitizedNumberOfMonths,
    sanitizedInterval,
    sanitizedPlanType,
    sanitizedAmountWithKlarnaInCents,
    sanitizedKlarnaDescription,
    sanitizedWeeklyPriceShort
  };
};
